// @flow

import React from 'react';
import bemify from 'bemify-js';

import Button from 'app/common/components/Button';
import FilterableZapsList from 'app/zap-mover/components/FilterableZapsList';
import ZapMoverAccountChoosersContainer from 'app/zap-mover/components/ZapMoverAccountChoosersContainer';
import { WarningBar } from 'app/common/components/MessageBar';
import {
  InfoBlock,
  InfoBlockContent,
  InfoBlockDescription,
  InfoBlockFooter,
  InfoBlockTitle,
} from 'app/common/components/InfoBlock';

const numberToMoveButtonCopy = {
  '0': () => 'Select Zaps from the list above',
  '1': () => 'Move this Zap',
  default: numZaps => `Move these ${numZaps} Zaps`,
};

type Props = {
  fromAccountId: number,
  selectedZapIds: Array<number>,
  toAccountId: number,
  toAccountName: string,
  onMoveZaps: (number, number, Array<number>) => void,
};

const bem = bemify('zap-mover');

const ZapMover = (props: Props) => {
  const numZaps = props.selectedZapIds.length;
  const btnText = (
    numberToMoveButtonCopy[numZaps] || numberToMoveButtonCopy.default
  )(numZaps);
  const content =
    props.fromAccountId && props.toAccountId ? (
      <div>
        <InfoBlockContent>
          <FilterableZapsList
            fromAccountId={props.fromAccountId}
            toAccountId={props.toAccountId}
          />
        </InfoBlockContent>
        <InfoBlockDescription kind="centered">
          We’ll tally any Zaps you move to {props.toAccountName} as part of that
          account’s usage.
        </InfoBlockDescription>
        <InfoBlockFooter>
          <Button
            disabled={numZaps === 0}
            kind="primary xlarge min-width"
            onClick={() =>
              props.onMoveZaps(
                props.fromAccountId,
                props.toAccountId,
                props.selectedZapIds
              )
            }
          >
            {btnText}
          </Button>
        </InfoBlockFooter>
      </div>
    ) : (
      <WarningBar kind="marginless">
        Choose a From account and a To account to move Zaps between them.
      </WarningBar>
    );
  return (
    <InfoBlock className={bem()} kind="page page-large">
      <InfoBlockTitle>Move Zaps</InfoBlockTitle>
      <InfoBlockDescription kind="centered">
        Select where you want to move your Zaps from and to…
      </InfoBlockDescription>
      <ZapMoverAccountChoosersContainer
        fromAccountId={props.fromAccountId}
        toAccountId={props.toAccountId}
      />
      {content}
    </InfoBlock>
  );
};

export default ZapMover;
